"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RewardDefinition = void 0;
class RewardDefinition {
    rewardType;
    configSchema;
    dataSchema;
    configurationValidator;
    submissionValidator;
    constructor(rewardType, configSchema, dataSchema, configurationValidator, submissionValidator) {
        this.rewardType = rewardType;
        this.configSchema = configSchema;
        this.dataSchema = dataSchema;
        this.configurationValidator = configurationValidator;
        this.submissionValidator = submissionValidator;
    }
}
exports.RewardDefinition = RewardDefinition;
//# sourceMappingURL=RewardDefinition.js.map